import { App, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { type ReactNode, useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useAppearanceTheme } from './AppearanceProvider';
import { OfflineBanner } from './components/OfflineBanner';
import { RootErrorBoundary } from './components/RootErrorBoundary';
import { routerBasename } from './runtimePaths';
import { useUiDensity } from './UiDensityProvider';
import { getUiDensityTheme } from './uiDensityTheme';

export function AppProviders({ children }: { children: ReactNode }) {
  const theme = useAppearanceTheme();
  const { systemDensity } = useUiDensity();
  const densityTheme = useMemo(
    () => getUiDensityTheme(theme, systemDensity),
    [theme, systemDensity],
  );
  return (
    <RootErrorBoundary>
      <ConfigProvider locale={zhCN} variant="filled" theme={densityTheme}>
        <App>
          <OfflineBanner />
          <BrowserRouter basename={routerBasename()}>{children}</BrowserRouter>
        </App>
      </ConfigProvider>
    </RootErrorBoundary>
  );
}
